var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_2938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91548 11.9596C2.54342 11.9596 2.27897 11.7936 2.12215 11.4616C1.96524 11.1295 2.0031 10.8206 2.23576 10.535L5.54048 6.51889V2.91797H4.84501C4.72105 2.91797 4.61712 2.87602 4.53321 2.79211C4.44941 2.70821 4.40751 2.60428 4.40751 2.48032C4.40751 2.35627 4.44941 2.25239 4.53321 2.16868C4.61712 2.08487 4.72105 2.04297 4.84501 2.04297H9.15263C9.27659 2.04297 9.38052 2.08492 9.46442 2.16882C9.54823 2.25273 9.59013 2.35666 9.59013 2.48061C9.59013 2.60467 9.54823 2.70855 9.46442 2.79226C9.38052 2.87607 9.27659 2.91797 9.15263 2.91797H8.45715V6.51889L11.7619 10.535C11.9945 10.8206 12.0324 11.1295 11.8755 11.4616C11.7187 11.7936 11.4542 11.9596 11.0822 11.9596H2.91548ZM2.91548 11.0846H11.0822L7.58215 6.8263V2.91797H6.41549V6.8263L2.91548 11.0846Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_2938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabWhite);
export default __webpack_public_path__ + "static/media/LabWhite.bdc0e8973ebab9896fca001a1f89d5f0.svg";
export { ForwardRef as ReactComponent };